export default "__VITE_ASSET__fe1148f0__"